<template>
  <div>
    <title-bar title="节能预估统计">
      <el-button type="default" @click="$router.back()" icon="fa fa-angle-left">返回</el-button>
    </title-bar>
    <el-alert
        title="预估公式： 预估节电费用 =（新风运行时长 - 空调运行时长）× 空调功率 × 电费"
        type="success">
    </el-alert>
    <div class="page-body">
      <el-form v-model="queryForm" inline>
        <el-form-item label="统计年月">
          <el-select v-model="queryForm.y" style="width: 100px">
            <el-option v-for="y in years" :value="y" :label="y+'年'"></el-option>
          </el-select>
          <el-select v-model="queryForm.startM" style="width: 80px">
            <el-option v-for="m of 12" :value="m" :label="m+'月'"></el-option>
          </el-select>
          至
          <el-select v-model="queryForm.endM" style="width: 80px">
            <el-option v-for="m of 12" :value="m" :label="m+'月'"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="新风预估功率">
          <el-input-number v-model="queryForm.fanPower" :min="0" :controls="false">
            <template slot="append">W</template>
          </el-input-number>
        </el-form-item>
        <el-form-item label="空调预估功率">
          <el-input-number v-model="queryForm.acPower" :min="0" :controls="false">
            <template slot="append">W</template>
          </el-input-number>
        </el-form-item>
        <el-form-item label="预估电费">
          <el-input-number v-model="queryForm.powerPrice" :min="0" :controls="false">
            <template slot="append">元</template>
          </el-input-number>
        </el-form-item>
        <el-button type="primary" icon="fa fa-search" :loading="loading" @click="query">查询</el-button>
      </el-form>

      <el-table stripe :data="records" :border="true" v-loading="loading">
        <el-table-column type="index" label="序号" width="50" align="center"></el-table-column>
        <el-table-column prop="compName" label="单位名称" min-width="180"></el-table-column>
        <el-table-column label="新风能耗" align="center">
          <el-table-column prop="fanRunHours" label="运行（小时）" align="center" min-width="90"></el-table-column>
          <el-table-column prop="fanPower" label="能耗（KWH）" align="center" min-width="90"></el-table-column>
          <el-table-column prop="fanMoney" label="费用（元）" align="center" min-width="90"></el-table-column>
        </el-table-column>
        <el-table-column label="空调能耗" align="center">
          <el-table-column prop="acRunHours" label="运行（小时）" align="center" min-width="90"></el-table-column>
          <el-table-column prop="acPower" label="能耗（KWH）" align="center" min-width="90"></el-table-column>
          <el-table-column prop="acMoney" label="费用（元）" align="center" min-width="90"></el-table-column>
        </el-table-column>
        <el-table-column label="总能耗" align="center">
          <el-table-column prop="totalPower" label="能耗（KWH）" align="center" min-width="90"></el-table-column>
          <el-table-column prop="totalMoney" label="费用（元）" align="center" min-width="90"></el-table-column>
        </el-table-column>
        <el-table-column label="预估节能" align="center">
          <el-table-column prop="savePower" label="节能（KWH）" align="center" min-width="90"></el-table-column>
          <el-table-column prop="saveMoney" label="节电费用（元）" align="center" min-width="120"></el-table-column>
          <el-table-column prop="savePct" label="节电率（%）" align="center" min-width="90">
            <template slot-scope="{row, $index}">
              <span>{{ (row.savePower/(row.savePower+row.totalPower)*100).toFixed(1) }} </span>
            </template>
          </el-table-column>
        </el-table-column>
      </el-table>
      <table-pagination :page-query="queryForm" :total="total" @change="loadData"></table-pagination>
    </div>
  </div>
</template>

<script>
import TitleBar from "@/components/base/TitleBar";
import TablePagination from "@/components/base/TablePagination";
import BaseVue from "@/components/base/BaseVue";
export default {
  components: {TablePagination, TitleBar},
  extends: BaseVue,
  data() {
    return {
      years: [],
      queryForm: {
        y: new Date().getFullYear(),
        startM: 1,
        endM: 12,
        fanPower: 300,
        acPower: 2200,
        powerPrice: 0.75,
        page: 1,
        limit: 10
      },
      total: 0,
      records: []
    }
  },
  created() {
    for(let i=new Date().getFullYear();i>=2019;i--) {
      this.years.push(i);
    }
    this.query();
  },
  methods: {
    query(){
      this.queryForm.page = 1;
      this.loadData();
    },
    loadData() {
      this.loading = true;
      this.postForm("/report/savingPowerReport", this.queryForm, true).then(dr => {
        this.records = dr.rows;
        this.total = dr.total;
      }).finally(()=>{
        this.loading = false;
      })
    }
  }
}
</script>

<style scoped>

</style>